import { formatAbsenceRange } from './equipeUi';

export default function UpcomingAbsences({ absences = [], members = [], onSelectMember }) {
  const memberById = new Map((members || []).map((m) => [m.id, m]));

  return (
    <div className="rounded-2xl border border-gray-100 bg-white p-3 shadow-sm">
      <h2 className="mb-3 px-1 text-sm font-bold text-gray-900">Absences à venir</h2>
      {(absences || []).length === 0 ? (
        <p className="px-1 text-xs text-gray-500">Aucune absence planifiée.</p>
      ) : (
        <ul className="max-h-[200px] space-y-2 overflow-y-auto pr-0.5">
          {absences.map((a) => {
            const member = memberById.get(a.memberId);
            const name = member
              ? `${member.prenom} ${member.nom}`
              : `${a.prenom || ''} ${a.nom || ''}`.trim();
            const { title, detail } = formatAbsenceRange(
              a.dateDebut,
              a.dateFin,
              a.motif,
              a.type,
            );
            return (
              <li key={a.id}>
                <button
                  type="button"
                  onClick={() => onSelectMember?.(a.memberId, 'absences')}
                  className="w-full rounded-xl border border-amber-100 bg-amber-50/60 px-3 py-2 text-left transition hover:bg-amber-50"
                >
                  <p className="text-xs font-semibold text-gray-900">{name}</p>
                  <p className="text-xs text-amber-900">{title}</p>
                  <p className="text-[10px] text-amber-800">{detail}</p>
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
